import React from "react";
import {TextEditor}  from "./editorjs";


export function CreateText({ textinput, onTextChange,defaultData }) {

    // codesandbox
    // https://codesandbox.io/p/sandbox/github/Mediumtutorial/wysiwyg-editor-js-react/tree/main/?file=%2Fsrc%2FEditor.js&from-embed

    return (
        <TextEditor defaultData={defaultData} data={textinput} onChange={onTextChange} />
        // <div className="regular-margin-bottom">
        //     <textarea
        //         onChange={(e) => onTextChange(e.target.value)}
        //         value={textinput}
        //         placeholder="Type hier je tekst (Markdown wordt ondersteund)"
        //         rows="10"
        //         cols="50"
        //     />
        //     <h5 className="standard-margin-top">Voorbeeld</h5>
        //     <div className="preview-window standard-margin-bottom standard-rounded" dangerouslySetInnerHTML={{ __html: parseMarkdown(textinput) }}>
        //     </div>
        // </div>
    );
}


export function parseMarkdown(input) {
    function escapeHtml(text) {
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;',
        };
        return text.replace(/[&<>"']/g, (m) => map[m]);
    }

    const safeInput = escapeHtml(input);

    var parsed = safeInput
        .replace(/^### (.*$)/gim, '<h3>$1</h3>')
        .replace(/^## (.*$)/gim, '<h2>$1</h2>')
        .replace(/^# (.*$)/gim, '<h1>$1</h1>')
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') 
        .replace(/_(.*?)_/g, '<em>$1</em>')              
        .replace(/~~(.*?)~~/g, '<del>$1</del>')          
        .replace(/\`(.*?)\`/g, '<code>$1</code>')        
        .replace(/^\* (.*?)(\n|$)/gm, '<li>$1</li>')
        .replace(/(<li>.*?<\/li>)+/g, '<ul>$&</ul>')
        .replace(/(?<!<\/h1>|<\/h2>|<\/h3>)\n/g, '<br>');

    if (input === "") {
        parsed = `<span style="color: #777;">Hier wordt een voorbeeld van je tekst getoond.</span>`;
    }

    return parsed;
}